import { Component } from '@theme/component';
/* global Fancybox */
let lastInteraction = 'pointer';
document.addEventListener(
  'keydown',
  (e) => {
    if (e.metaKey || e.ctrlKey || e.altKey) return;
    if (e.key === 'Tab' || e.key.startsWith('Arrow')) {
      lastInteraction = 'keyboard';
    }
  },
  true
);
document.addEventListener(
  'pointerdown',
  () => {
    lastInteraction = 'pointer';
  },
  { passive: true, capture: true }
);
if (!customElements.get('fancy-box-component')) {
  /**
   * Slideshow custom element that allows sliding between content.
   *
   * @typedef {Object} Refs
   * @property {HTMLElement[]} [trigger] - Elements that trigger the Fancybox when clicked.
   *
   * @extends {Component<Refs>}
   */
  class FancyBoxComponent extends Component {
    requiredRefs = ['trigger'];
    connectedCallback() {
      super.connectedCallback();
      this.init();
    }
    init() {
      if (typeof Fancybox === 'undefined') return;

      this.refs.trigger?.forEach((trigger) => {
        Fancybox.bind(`#${trigger.id}`, {
          on: {
            init: () => {
              const openDialog = this.getOpenDialog(trigger);

              if (openDialog) {
                trigger.__fancyboxDialog = openDialog;
                openDialog.close();
              }
            },

            destroy: () => {
              const dialog = trigger.__fancyboxDialog;

              if (dialog && !dialog.open) {
                dialog.showModal();
              }

              trigger.__fancyboxDialog = null;

              requestAnimationFrame(() => {
                if (lastInteraction === 'pointer' && document.activeElement === trigger) {
                  trigger.blur();
                }
              });
            },
          },
        });
      });
    }
    getOpenDialog(trigger) {
      // 1. Prefer the closest parent dialog if it's open
      const parentDialog = trigger.closest('dialog[open]');
      if (parentDialog) return parentDialog;

      // 2. Fallback: find any open dialog containing this component
      const containingDialog = this.closest('dialog[open]');
      if (containingDialog) return containingDialog;

      // 3. Last fallback: any open dialog on the page
      return document.querySelector('dialog[open]');
    }
  }

  customElements.define('fancy-box-component', FancyBoxComponent);
}
